import { TRIGGER_HOME_DETAILS_API, TRIGGER_HOME_DETAILS_API_SUCCESS } from 'redux/actionTypes';

export function triggerHomeDetailsApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_HOME_DETAILS_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerHomeDetailsApiCallSuccess(data) {
	return {
		type: TRIGGER_HOME_DETAILS_API_SUCCESS,
		data,
	};
}
